
import CustomFormContainer from './CustomFormContainer.vue';
import FormPopup from './FormPopup.vue';
import viewport from '~/mixins/viewport';

export default {
    name: 'CustomFormWrapper',
    mixins: [viewport],
    components: {
        CustomFormContainer,
        FormPopup,
    },
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            activePositions: [], // Массив активных позиций с их данными
        };
    },
    computed: {
        formProps() {
            return {
                block_title: this.form.block_title,
                form_title: this.form.form_title,
                description: this.form.description,
                backgroundImage: this.form.background_image,
                submitButtonText: this.form.submit_button_text,
                fields: this.form.fields,
            };
        },
    },
    mounted() {
        this.processPositions();
    },
    methods: {
        settingsForButtonOnProductPage(positionData) {
            const onProductPage =
                positionData.position.default_position === 'product_page' && this.$route.path.includes('/product/');
            return positionData.position.show_type === 'popup' && onProductPage;
        },
        processPositions() {
            if (!this.form || !this.form.positions) return;

            // Очищаем предыдущие активные позиции
            this.activePositions = [];

            this.form.positions.forEach((position, positionIndex) => {
                const onMainPage = position.default_position === 'main_page' && this.$route.path === `/${this.$i18n.locale}`;
                const onProductPage = position.default_position === 'product_page' && this.$route.path.includes('/product/');

                if ((onMainPage || onProductPage) && !position?.key_class) {
                    // Добавляем позицию в активные
                    const positionData = {
                        position: position,
                        originalIndex: positionIndex,
                        shouldRender: false,
                        targetElement: null,
                    };

                    this.activePositions.push(positionData);
                    const currentIndex = this.activePositions.length - 1;

                    if (position.show_type === 'render' && onMainPage) {
                        setTimeout(() => {
                            this.findAndPosition(
                                { ...position, key_class: 'top-video-checkpoint', position: 'before' },
                                currentIndex
                            );
                        }, 1000);
                    } else if (position.show_type === 'popup' && onProductPage) {
                        setTimeout(() => {
                            if (this.isUnderOrEqualViewport1024) {
                                this.findAndPosition(
                                    { ...position, key_class: 'subscribe__content', position: 'after', key_class_number: 1 },
                                    currentIndex
                                );
                            } else {
                                this.findAndPosition(
                                    { ...position, key_class: 'subscribe__content', position: 'after', key_class_number: 0 },
                                    currentIndex
                                );
                            }
                        }, 1000);
                    } else {
                        setTimeout(() => {
                            if (position.key_class) {
                                this.findAndPosition(position, currentIndex);
                            } else {
                                this.activePositions[currentIndex].shouldRender = true;
                            }
                        }, 1000);
                    }
                } else if (position?.key_class) {
                    // Добавляем позицию в активные
                    const positionData = {
                        position: position,
                        originalIndex: positionIndex,
                        shouldRender: false,
                        targetElement: null,
                    };

                    this.activePositions.push(positionData);
                    const currentIndex = this.activePositions.length - 1;

                    setTimeout(() => {
                        if (position.key_class) {
                            this.findAndPosition(position, currentIndex);
                        } else {
                            this.activePositions[currentIndex].shouldRender = true;
                        }
                    }, 1000);
                }
            });
        },

        findAndPosition(position, wrapperIndex) {
            // Даем DOM время на отрисовку
            setTimeout(() => {
                this.$nextTick(() => {
                    const elements = document.getElementsByClassName(position.key_class);

                    if (elements.length > 0) {
                        const keyClassElement = elements[position.key_class_number || 0];
                        this.activePositions[wrapperIndex].targetElement = keyClassElement;
                        this.activePositions[wrapperIndex].shouldRender = true;

                        // Форсируем обновление реактивности
                        this.$forceUpdate();

                        if (position.show_type === 'popup') {
                            this.$nextTick(() => {
                                const el = this.$refs[`wrapper-${wrapperIndex}`]?.[0]?.querySelector('.custom-form-component');

                                if (el?.parentNode) {
                                    el.parentNode.removeChild(el);
                                    document.body.appendChild(el);
                                }
                            });
                        }

                        this.$nextTick(() => {
                            const wrapperEl = this.$refs[`wrapper-${wrapperIndex}`]?.[0];
                            if (wrapperEl && keyClassElement) {
                                if (position.position === 'after') {
                                    keyClassElement.parentNode.insertBefore(wrapperEl, keyClassElement.nextSibling);
                                } else if (position.position === 'inside') {
                                    keyClassElement.insertBefore(wrapperEl, keyClassElement.firstChild);
                                } else {
                                    keyClassElement.parentNode.insertBefore(wrapperEl, keyClassElement);
                                }
                            }
                        });
                    }
                });
            }, 0);
        },

        getComponentForPosition(position) {
            return position.show_type === 'popup' ? 'FormPopup' : 'CustomFormContainer';
        },

        openPopup(index) {
            const formComp = this.$refs[`formComp-${index}`];
            if (formComp && formComp[0] && typeof formComp[0].openPopup === 'function') {
                formComp[0].openPopup();
            }
        },
    },
    watch: {
        '$route.path': {
            handler: 'processPositions',
            immediate: false,
        },
        isUnderOrEqualViewport1024: {
            handler: 'processPositions',
            immediate: false,
        },
    },
};
